import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {Cost} from "../../models/cost";
import {Registration} from "../../models/registration";

@Directive()
@Injectable()
export class CostService {

  public serviceId: string;
  public registration: Registration;
  public registrationCostList: any;
  public costView: any;
  public cost: Cost;
  public addNew: boolean;
  public showDeterminantBuilder: boolean;

  @Output() public editData: EventEmitter<any> = new EventEmitter();
  @Output() public change: EventEmitter<any> = new EventEmitter();
  @Output() public update: EventEmitter<any> = new EventEmitter();
  @Output() public changeFormula: EventEmitter<any> = new EventEmitter();

  public initData() {
    this.change.emit({
      registration: this.registration,
      serviceId: this.serviceId,
      registrationCostList: this.registrationCostList,
    });
  }

  public initEdit() {
    this.editData.emit({
      serviceId: this.serviceId,
      registration: this.registration,
      cost: this.cost,
      costView: this.costView,
      addNew: this.addNew,
      showDeterminantBuilder: this.showDeterminantBuilder,
    });
  }

  public updateData() {
    this.update.emit({
      update: true,
    });
  }

  public updateFormula() {
    this.changeFormula.emit({
      costView: this.costView,
    });
  }

}
